export default __webpack_public_path__ + "static/media/schedule-sip-icon.2544d994.svg";